import { useQuery } from "@tanstack/react-query";
import { useServices } from "index";

export const useGetModuleProgress = (selectedClassId: string, selectedModuleId: string, isModuleProgressQueryEnabled: boolean) => {
  const moduleProgressService = useServices().moduleProgressService;
  return useQuery({
    queryKey: ['moduleProgress', `${selectedClassId}-${selectedModuleId}`],
    queryFn: () => moduleProgressService.getClassProgressForSelectedModule(selectedClassId, selectedModuleId),
    enabled: isModuleProgressQueryEnabled,
    refetchOnWindowFocus: false,
  });
}